'use client';

import { datadogLogs, Site } from '@datadog/browser-logs';
import type { IDatadogService } from '../types/analytics.types';
import { logger } from '@/core/logger';

class DatadogService implements IDatadogService {
	private initialized: boolean = false;
	private clientToken: string;
	private site: string;
	private service: string;
	private env: string;

	constructor() {
		const clientToken = process.env.NEXT_PUBLIC_DD_CLIENT_TOKEN;
		const site = process.env.NEXT_PUBLIC_DD_SITE;
		const service = process.env.NEXT_PUBLIC_DD_SERVICE;
		const env = process.env.NEXT_PUBLIC_ENV;

		if (!clientToken || !site || !service || !env) {
			logger.warn(
				'Datadog not configured: NEXT_PUBLIC_DD_CLIENT_TOKEN, NEXT_PUBLIC_DD_SITE, NEXT_PUBLIC_DD_SERVICE, NEXT_PUBLIC_ENV environment variables are missing'
			);
			this.clientToken = '';
			this.site = '';
			this.service = '';
			this.env = '';
			return;
		}

		this.clientToken = clientToken;
		this.site = site;
		this.service = service;
		this.env = env;
	}

	initialize(): boolean {
		// Skip if not configured
		if (!this.clientToken || !this.site || !this.service || !this.env) {
			return false;
		}

		// Prevent re-initialization
		if (this.initialized) {
			return true;
		}

		try {
			datadogLogs.init({
				clientToken: this.clientToken,
				site: this.site as Site,
				forwardErrorsToLogs: true,
				forwardConsoleLogs: 'all', // Capture all console logs automatically
				forwardReports: 'all',
				service: this.service,
				env: this.env,
				sessionSampleRate: 100,
			});
			this.initialized = true;
			return true;
		} catch (error) {
			logger.error('Failed to initialize Datadog', error);
			return false;
		}
	}
}

export const datadogService = new DatadogService();
